import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
const FileSaver = require('file-saver');

@Component({
  selector: 'app-requested-documents',
  templateUrl: './requested-documents.component.html',
  styleUrls: ['./requested-documents.component.scss']
})
export class RequestedDocumentsComponent implements OnInit {

  responseHolder: any;
  Key:any="";
  spinner:boolean=false;
  folderList:any=[];
  requestDetail:any;
  requestExpiryDate:string="";
  senderFirstName:string="";
  senderLastName:string="";
  subject:string="";
  message:string="";
  ShowSubmitButton: boolean = false;
  ResponseHolderDetails: any;
  formData: FormData = new FormData();
  UploadedFiles = [];
  requestID:any;
  TransactionID:any;
  DocumentFolderID:any;
  status:boolean=false;
  type:string="";

  constructor(private dialog: MatDialog,private router:Router,private route: ActivatedRoute,
    private formsService:FormsService,private loaderService: LoaderService,private toastr: ToastrService,
    private cdr: ChangeDetectorRef,private statusConstant: StatusConstant,
    private encryptionAlgo: EncryptionService,private reusableClass: ReusableClasses) 
    { } 

  ngOnInit(): void {
    this.getQueryParameter();
    sessionStorage.setItem('ParticipantDocumentUpload','false');
    this.RequestCCCUrlVisit();
  }

  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.Key = params['Key'];
      this.type = params['type']
  });   
  //  if(this.type.toLowerCase()=="core"){
  //   this.RequestCoreUrlVisit();
  //  }
  //  if(this.type.toLowerCase()=="contact"){
  //   this.RequestContactUrlVisit();
  //  }
  //  if(this.type.toLowerCase()=="company"){
  //   this.RequestCompanyUrlVisit();
  //  }
  }

  byPortalEmail:string="";

  // For Core/Contact/Company
  RequestCCCUrlVisit() {
    let reqModel ={
      key:encodeURIComponent(decodeURIComponent(this.Key)),
      password: ""
    }
    this.spinner=true;
    this.formsService.RequestCCCUrlVisit(reqModel,this.type).subscribe(response=>{
      if (response != undefined){
        this.spinner=false;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.requestDetail = this.responseHolder.data.requestDetail;
          var statusId= this.responseHolder.data.contact.status;
          if(statusId > 0){
            this.status=true;
            if(sessionStorage.getItem("ParticipantDocumentUpload")!="true"){
              this.toastr.warning('Request already completed by you.', '', {
                timeOut: 3000,
              });
            }           
          }else{
            this.status=false;
          }
          this.requestID = this.responseHolder.data.requestDetail.requestID;
          if(this.type.toLowerCase()=="core"){
            this.TransactionID = this.responseHolder.data.requestDetail.coreID;
          }
          if(this.type.toLowerCase()=="contact"){
            this.TransactionID = this.responseHolder.data.requestDetail.contactID;
          }
          if(this.type.toLowerCase()=="company"){
            this.TransactionID = this.responseHolder.data.requestDetail.companyID;
          }
          this.folderList = this.responseHolder.data.requestPlaceholders;
          this.requestExpiryDate=this.responseHolder.data.requestDetail.requestExpiryDate;

          this.senderFirstName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.responseHolder.data.requestDetail.senderFirstName);
          this.senderLastName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.responseHolder.data.requestDetail.senderLastName);

          this.subject=this.responseHolder.data.requestDetail.subject;
          this.message=this.responseHolder.data.requestDetail.message;  
          
          this.byPortalEmail = this.responseHolder.data.contact.email;
         
        }else{
          this.spinner=false;
        }
      }else{
        this.spinner=false;
      }    
    });
  }

   

  DownloadFile(doc: any) {
    if(doc.base64){
      FileSaver.saveAs(doc.base64, doc.fileName);
      return;
    }
    if(!doc.base64){
    this.spinner=true;
    this.formsService.getAttachment(doc.documentName, doc.documentPath).subscribe((response) => {
    if (response !== undefined) {
        const data = 'data:' + response.data.contentType +';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, doc.documentName);
        this.spinner=false;
       }else{
        this.spinner=false;
       }
    });
   }  
  }

  UploadFile(event: any, document) {
    if (event.target.files.length > 0) {
      let files = event.target.files;   
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = files[0].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
        var base64String = reader.result;

        var ReqModel = {
          placeholderID:document.placeholderID,
          DocumentFolderID:document.documentFolderID,
          fileName: documentName,
          base64: base64String,
          documentType: documenttype,
          file: files[0]
        };
        this.folderList.find((item) => item.placeholderID == document.placeholderID).documentType = documenttype;
        this.folderList.find((item) => item.placeholderID == document.placeholderID).base64 = base64String;
        this.folderList.find((item) => item.placeholderID == document.placeholderID).fileName = documentName;
        const index = this.UploadedFiles.findIndex(el => el.placeholderID === document.placeholderID);
          if (index >= 0) {
          this.UploadedFiles.splice(index, 1);
         }
        this.UploadedFiles.push(ReqModel);
      };
      this.ShowSubmitButton=true;
      this.cdr.detectChanges();  
    } else {
    }
  }
  

  SubmitDocument(IsSubmit) {
    this.spinner=true;
    this.formData.append('Key',encodeURIComponent(decodeURIComponent(this.Key)));
    this.formData.append('IsSubmit', IsSubmit);
    this.formData.append('Password', "");
    this.formData.append('ByPortal', this.byPortalEmail);
    this.formData.append('RequestID', this.requestID);
    this.formData.append('TransactionID', this.TransactionID);
     if(this.UploadedFiles.length > 0) {
     for (let i = 0; i < this.UploadedFiles.length; i++) {
      if(this.UploadedFiles[i].file!=='') {
            var FullPath = this.UploadedFiles[i].file.name;
            var documentNameSplit = FullPath.split('.');
            var documentName = documentNameSplit[0];
            var documenttype = documentNameSplit[1];
            var DocumentFolderID = this.UploadedFiles[i].DocumentFolderID;
            var PlaceholderID =this.UploadedFiles[i].placeholderID;
    
            // DocumentName|FileType|PlaceholderID|CoreID|DocumentFolderID  Sequence for send paramter

            // file region
            this.formData.append('files', this.UploadedFiles[i].file);
            this.formData.append('filesData',documentName + '|' + documenttype + '|' + PlaceholderID +'|'+ this.TransactionID +'|'+ DocumentFolderID);            
        }     
      }
    }
    //return;
    this.formsService.ParticipantDocumentUploadCCC(this.formData,this.type).subscribe((response) => {
        if (response != undefined) {
          this.ResponseHolderDetails = response;
          if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {
            sessionStorage.setItem('ParticipantDocumentUpload','true');
            this.RequestCCCUrlVisit();
            this.toastr.success('Document uploaded successfully.', '', {
              timeOut: 3000,
            });
            this.ShowSubmitButton=false; 
            this.UploadedFiles = [];
            this.spinner=false;
            this.status=true;
          } else {
            this.ShowSubmitButton=false;
            this.UploadedFiles = [];
            this.spinner=false;
            this.status=true;
          }
        }else {
          this.ShowSubmitButton=false;
          this.UploadedFiles = [];
          this.spinner=false;
          this.status=true;
        }
      });
  
  }




  // For Contact
  //  RequestContactUrlVisit() {
  //   let reqModel ={
  //     key:encodeURIComponent(decodeURIComponent(this.Key)),
  //     password: ""
  //   }
  //   this.spinner=true;
  //   this.formsService.RequestContactUrlVisit(reqModel).subscribe(response=>{
  //     if (response != undefined){
  //       this.spinner=false;
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //         this.requestDetail = this.responseHolder.data.requestDetail;
  //         var statusId= this.responseHolder.data.contact.status;
  //         if(statusId > 0){
  //           this.status=true;
  //           if(sessionStorage.getItem("ParticipantDocumentUpload")!="true"){
  //             this.toastr.warning('Request already completed by you.', '', {
  //               timeOut: 3000,
  //             });
  //           }           
  //         }else{
  //           this.status=false;
  //         }
  //         this.requestID = this.responseHolder.data.requestDetail.requestID;
  //         this.TransactionID = this.responseHolder.data.requestDetail.coreID;
  //         this.folderList = this.responseHolder.data.requestPlaceholders;
  //         this.requestExpiryDate=this.responseHolder.data.requestDetail.requestExpiryDate;

  //         this.senderFirstName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.responseHolder.data.requestDetail.senderFirstName);
  //         this.senderLastName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.responseHolder.data.requestDetail.senderLastName);

  //         this.subject=this.responseHolder.data.requestDetail.subject;
  //         this.message=this.responseHolder.data.requestDetail.message;         
         
  //       }else{
  //         this.spinner=false;
  //       }
  //     }else{
  //       this.spinner=false;
  //     }    
  //   });
  // }

   // For Company
  //  RequestCompanyUrlVisit() {
  //   let reqModel ={
  //     key:encodeURIComponent(decodeURIComponent(this.Key)),
  //     password: ""
  //   }
  //   this.spinner=true;
  //   this.formsService.RequestCompanyUrlVisit(reqModel).subscribe(response=>{
  //     if (response != undefined){
  //       this.spinner=false;
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //         this.requestDetail = this.responseHolder.data.requestDetail;
  //         var statusId= this.responseHolder.data.contact.status;
  //         if(statusId > 0){
  //           this.status=true;
  //           if(sessionStorage.getItem("ParticipantDocumentUpload")!="true"){
  //             this.toastr.warning('Request already completed by you.', '', {
  //               timeOut: 3000,
  //             });
  //           }           
  //         }else{
  //           this.status=false;
  //         }
  //         this.requestID = this.responseHolder.data.requestDetail.requestID;
  //         this.TransactionID = this.responseHolder.data.requestDetail.coreID;
  //         this.folderList = this.responseHolder.data.requestPlaceholders;
  //         this.requestExpiryDate=this.responseHolder.data.requestDetail.requestExpiryDate;

  //         this.senderFirstName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.responseHolder.data.requestDetail.senderFirstName);
  //         this.senderLastName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.responseHolder.data.requestDetail.senderLastName);

  //         this.subject=this.responseHolder.data.requestDetail.subject;
  //         this.message=this.responseHolder.data.requestDetail.message;         
         
  //       }else{
  //         this.spinner=false;
  //       }
  //     }else{
  //       this.spinner=false;
  //     }    
  //   });
  // }



}
